import '../styles/components/NavBar.css'

import logo from '../assets/andreaBrunoriLogo.png'

function NavBar()
{
    
    return(
        <nav>
            <div className='navContainer'>
                <img src={logo}></img>
            </div>
        </nav>
    );
    
}

export default NavBar;